import createReducer from './createReducer';
import * as actions from '../actions/actionTypes';
import { mergeAll } from 'ramda';

const loanApplicationReducer = createReducer({}, {
  [actions.LANDING_FORM_SUBMITTED]: (state, action) =>
    mergeAll([
      state,
      {
        loanAmount: action.data.loanAmount,
        loanPurpose: action.data.loanPurpose
      }
    ]),

  [actions.PROSPECT_VALIDATED]: (state, action) =>
    mergeAll([
      state,
      {
        prospectId: action.data.prospect.id,
        firstName: action.data.prospect.name.firstName,
        homeAddress: action.data.prospect.address.lineOne
      }
    ]),

  [actions.CHECK_YOUR_RATE_FORM_SUBMITTED]: (state, action) =>
    mergeAll([
      state,
      action.data
    ]),

  [actions.QUOTE_RECEIVED]: (state, action) => {
    const quote = action.quote;
    if (quote.status === 'DECLINED') {
      return {
        applicationId: state.applicationId,
        quoteId: state.quoteId,
        status: quote.status
      };
    } else {
      return mergeAll([
        state,
        quote
      ]);
    }
  },

  [actions.SELECT_OFFER_FORM_SUBMITTED]: (state, action) =>
    mergeAll([
      state,
      { selectedQuote: action.data },
      { loanAmount: action.data.loanAmount.amount }
    ]),

  [actions.APPLICATION_DECISION]: (state, action) =>
    mergeAll([
      state,
      action.data
    ]),

  [actions.APPLICATION_DATA_RESET]: (state, action) => ({}),

  [actions.LOAN_APPLICATION_RECEIVED]: (state, action) =>
    mergeAll([
      state,
      action.loanApplication
    ]),

  [actions.CUSTOMER_INFO_FROM_TOKEN_RECEIVED]: (state, action) =>
    mergeAll([
      state,
      action.loanApplication
    ])

});

export default loanApplicationReducer;
